import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6351a3b4 = () => interopDefault(import('../pages/accessibilite.vue' /* webpackChunkName: "pages/accessibilite" */))
const _437dba42 = () => interopDefault(import('../pages/bureau-etude-urbanisme.vue' /* webpackChunkName: "pages/bureau-etude-urbanisme" */))
const _bc227d1c = () => interopDefault(import('../pages/collectivites-territoriales.vue' /* webpackChunkName: "pages/collectivites-territoriales" */))
const _d4686404 = () => interopDefault(import('../pages/confidentialite.vue' /* webpackChunkName: "pages/confidentialite" */))
const _18f0e9eb = () => interopDefault(import('../pages/ddt-ddtm-dreal.vue' /* webpackChunkName: "pages/ddt-ddtm-dreal" */))
const _9824ea30 = () => interopDefault(import('../pages/guide.vue' /* webpackChunkName: "pages/guide" */))
const _6a231398 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _35e0264d = () => interopDefault(import('../pages/loi-climat-et-resilience.vue' /* webpackChunkName: "pages/loi-climat-et-resilience" */))
const _a7d6bf32 = () => interopDefault(import('../pages/mentions-legales.vue' /* webpackChunkName: "pages/mentions-legales" */))
const _23014564 = () => interopDefault(import('../pages/stats/index.vue' /* webpackChunkName: "pages/stats/index" */))
const _87a6e086 = () => interopDefault(import('../pages/validation.vue' /* webpackChunkName: "pages/validation" */))
const _0d7c620c = () => interopDefault(import('../pages/dev/api.vue' /* webpackChunkName: "pages/dev/api" */))
const _5230311e = () => interopDefault(import('../pages/login/collectivites/explain.vue' /* webpackChunkName: "pages/login/collectivites/explain" */))
const _4dcf164b = () => interopDefault(import('../pages/login/collectivites/signin.vue' /* webpackChunkName: "pages/login/collectivites/signin" */))
const _62656cc1 = () => interopDefault(import('../pages/login/collectivites/signup.vue' /* webpackChunkName: "pages/login/collectivites/signup" */))
const _e594e5bc = () => interopDefault(import('../pages/login/ddt/explain.vue' /* webpackChunkName: "pages/login/ddt/explain" */))
const _266c29c7 = () => interopDefault(import('../pages/login/ddt/signin.vue' /* webpackChunkName: "pages/login/ddt/signin" */))
const _3b02803d = () => interopDefault(import('../pages/login/ddt/signup.vue' /* webpackChunkName: "pages/login/ddt/signup" */))
const _00e0c484 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _1bb49d8e = () => interopDefault(import('../pages/collectivites/_code_collectivite.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite" */))
const _0c6ca8fc = () => interopDefault(import('../pages/collectivites/_code_collectivite/index.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/index" */))
const _dc6dc5dc = () => interopDefault(import('../pages/collectivites/_code_collectivite/donnees.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/donnees" */))
const _02913037 = () => interopDefault(import('../pages/collectivites/_code_collectivite/donnees/data.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/donnees/data" */))
const _68539cf4 = () => interopDefault(import('../pages/collectivites/_code_collectivite/donnees/geoide.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/donnees/geoide" */))
const _aef6f86c = () => interopDefault(import('../pages/collectivites/_code_collectivite/donnees/georisques.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/donnees/georisques" */))
const _65c3e7af = () => interopDefault(import('../pages/collectivites/_code_collectivite/donnees/gpu.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/donnees/gpu" */))
const _98e83c20 = () => interopDefault(import('../pages/collectivites/_code_collectivite/donnees/inpn.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/donnees/inpn" */))
const _b1570de6 = () => interopDefault(import('../pages/collectivites/_code_collectivite/informations.vue' /* webpackChunkName: "pages/collectivites/_code_collectivite/informations" */))
const _6b9c464a = () => interopDefault(import('../pages/collectivites/_collectiviteId.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId" */))
const _63b91e40 = () => interopDefault(import('../pages/collectivites/_collectiviteId/glossaire.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/glossaire" */))
const _247171cd = () => interopDefault(import('../pages/collectivites/_collectiviteId/pac.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/pac" */))
const _2dd3dd17 = () => interopDefault(import('../pages/collectivites/_collectiviteId/prescriptions/index.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/prescriptions/index" */))
const _cd613ea6 = () => interopDefault(import('../pages/collectivites/_collectiviteId/ressources.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/ressources" */))
const _d94f16b4 = () => interopDefault(import('../pages/collectivites/_collectiviteId/prescriptions/add.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/prescriptions/add" */))
const _444e72a3 = () => interopDefault(import('../pages/collectivites/_collectiviteId/prescriptions/signup.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/prescriptions/signup" */))
const _32c64c27 = () => interopDefault(import('../pages/collectivites/_collectiviteId/procedures/add.vue' /* webpackChunkName: "pages/collectivites/_collectiviteId/procedures/add" */))
const _406cfce2 = () => interopDefault(import('../pages/ddt/_departement.vue' /* webpackChunkName: "pages/ddt/_departement" */))
const _6d673e5c = () => interopDefault(import('../pages/ddt/_departement/index.vue' /* webpackChunkName: "pages/ddt/_departement/index" */))
const _d7ca721a = () => interopDefault(import('../pages/ddt/_departement/collectivites/index.vue' /* webpackChunkName: "pages/ddt/_departement/collectivites/index" */))
const _3a032f2e = () => interopDefault(import('../pages/ddt/_departement/enquete.vue' /* webpackChunkName: "pages/ddt/_departement/enquete" */))
const _0554fadc = () => interopDefault(import('../pages/ddt/_departement/pac.vue' /* webpackChunkName: "pages/ddt/_departement/pac" */))
const _0f0befb3 = () => interopDefault(import('../pages/ddt/_departement/procedures/index.vue' /* webpackChunkName: "pages/ddt/_departement/procedures/index" */))
const _5d1e8874 = () => interopDefault(import('../pages/ddt/_departement/procedures/choix-collectivite.vue' /* webpackChunkName: "pages/ddt/_departement/procedures/choix-collectivite" */))
const _9dbd83a2 = () => interopDefault(import('../pages/ddt/_departement/collectivites/_collectiviteId/commune.vue' /* webpackChunkName: "pages/ddt/_departement/collectivites/_collectiviteId/commune" */))
const _f8b0e2dc = () => interopDefault(import('../pages/ddt/_departement/collectivites/_collectiviteId/epci.vue' /* webpackChunkName: "pages/ddt/_departement/collectivites/_collectiviteId/epci" */))
const _4494bb74 = () => interopDefault(import('../pages/ddt/_departement/collectivites/_collectiviteId/procedure/add.vue' /* webpackChunkName: "pages/ddt/_departement/collectivites/_collectiviteId/procedure/add" */))
const _6a18d814 = () => interopDefault(import('../pages/frise/_procedureId/index.vue' /* webpackChunkName: "pages/frise/_procedureId/index" */))
const _017db47b = () => interopDefault(import('../pages/print/_projectId.vue' /* webpackChunkName: "pages/print/_projectId" */))
const _733eed98 = () => interopDefault(import('../pages/trames/_githubRef.vue' /* webpackChunkName: "pages/trames/_githubRef" */))
const _0b4fb1a2 = () => interopDefault(import('../pages/documents/_githubRef/pac.vue' /* webpackChunkName: "pages/documents/_githubRef/pac" */))
const _3c665745 = () => interopDefault(import('../pages/frise/_procedureId/add.vue' /* webpackChunkName: "pages/frise/_procedureId/add" */))
const _9e0015d6 = () => interopDefault(import('../pages/frise/_procedureId/invite.vue' /* webpackChunkName: "pages/frise/_procedureId/invite" */))
const _57f31ed5 = () => interopDefault(import('../pages/frise/_procedureId/update.vue' /* webpackChunkName: "pages/frise/_procedureId/update" */))
const _6df62ea2 = () => interopDefault(import('../pages/frise/_procedureId/_eventId.vue' /* webpackChunkName: "pages/frise/_procedureId/_eventId" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/accessibilite",
    component: _6351a3b4,
    name: "accessibilite"
  }, {
    path: "/bureau-etude-urbanisme",
    component: _437dba42,
    name: "bureau-etude-urbanisme"
  }, {
    path: "/collectivites-territoriales",
    component: _bc227d1c,
    name: "collectivites-territoriales"
  }, {
    path: "/confidentialite",
    component: _d4686404,
    name: "confidentialite"
  }, {
    path: "/ddt-ddtm-dreal",
    component: _18f0e9eb,
    name: "ddt-ddtm-dreal"
  }, {
    path: "/guide",
    component: _9824ea30,
    name: "guide"
  }, {
    path: "/login",
    component: _6a231398,
    name: "login"
  }, {
    path: "/loi-climat-et-resilience",
    component: _35e0264d,
    name: "loi-climat-et-resilience"
  }, {
    path: "/mentions-legales",
    component: _a7d6bf32,
    name: "mentions-legales"
  }, {
    path: "/stats",
    component: _23014564,
    name: "stats"
  }, {
    path: "/validation",
    component: _87a6e086,
    name: "validation"
  }, {
    path: "/dev/api",
    component: _0d7c620c,
    name: "dev-api"
  }, {
    path: "/login/collectivites/explain",
    component: _5230311e,
    name: "login-collectivites-explain"
  }, {
    path: "/login/collectivites/signin",
    component: _4dcf164b,
    name: "login-collectivites-signin"
  }, {
    path: "/login/collectivites/signup",
    component: _62656cc1,
    name: "login-collectivites-signup"
  }, {
    path: "/login/ddt/explain",
    component: _e594e5bc,
    name: "login-ddt-explain"
  }, {
    path: "/login/ddt/signin",
    component: _266c29c7,
    name: "login-ddt-signin"
  }, {
    path: "/login/ddt/signup",
    component: _3b02803d,
    name: "login-ddt-signup"
  }, {
    path: "/",
    component: _00e0c484,
    name: "index"
  }, {
    path: "/collectivites/:code_collectivite?",
    component: _1bb49d8e,
    children: [{
      path: "",
      component: _0c6ca8fc,
      name: "collectivites-code_collectivite"
    }, {
      path: "donnees",
      component: _dc6dc5dc,
      name: "collectivites-code_collectivite-donnees",
      children: [{
        path: "data",
        component: _02913037,
        name: "collectivites-code_collectivite-donnees-data"
      }, {
        path: "geoide",
        component: _68539cf4,
        name: "collectivites-code_collectivite-donnees-geoide"
      }, {
        path: "georisques",
        component: _aef6f86c,
        name: "collectivites-code_collectivite-donnees-georisques"
      }, {
        path: "gpu",
        component: _65c3e7af,
        name: "collectivites-code_collectivite-donnees-gpu"
      }, {
        path: "inpn",
        component: _98e83c20,
        name: "collectivites-code_collectivite-donnees-inpn"
      }]
    }, {
      path: "informations",
      component: _b1570de6,
      name: "collectivites-code_collectivite-informations"
    }]
  }, {
    path: "/collectivites/:collectiviteId?",
    component: _6b9c464a,
    name: "collectivites-collectiviteId",
    children: [{
      path: "glossaire",
      component: _63b91e40,
      name: "collectivites-collectiviteId-glossaire"
    }, {
      path: "pac",
      component: _247171cd,
      name: "collectivites-collectiviteId-pac"
    }, {
      path: "prescriptions",
      component: _2dd3dd17,
      name: "collectivites-collectiviteId-prescriptions"
    }, {
      path: "ressources",
      component: _cd613ea6,
      name: "collectivites-collectiviteId-ressources"
    }, {
      path: "prescriptions/add",
      component: _d94f16b4,
      name: "collectivites-collectiviteId-prescriptions-add"
    }, {
      path: "prescriptions/signup",
      component: _444e72a3,
      name: "collectivites-collectiviteId-prescriptions-signup"
    }, {
      path: "procedures/add",
      component: _32c64c27,
      name: "collectivites-collectiviteId-procedures-add"
    }]
  }, {
    path: "/ddt/:departement?",
    component: _406cfce2,
    children: [{
      path: "",
      component: _6d673e5c,
      name: "ddt-departement"
    }, {
      path: "collectivites",
      component: _d7ca721a,
      name: "ddt-departement-collectivites"
    }, {
      path: "enquete",
      component: _3a032f2e,
      name: "ddt-departement-enquete"
    }, {
      path: "pac",
      component: _0554fadc,
      name: "ddt-departement-pac"
    }, {
      path: "procedures",
      component: _0f0befb3,
      name: "ddt-departement-procedures"
    }, {
      path: "procedures/choix-collectivite",
      component: _5d1e8874,
      name: "ddt-departement-procedures-choix-collectivite"
    }, {
      path: "collectivites/:collectiviteId/commune",
      component: _9dbd83a2,
      name: "ddt-departement-collectivites-collectiviteId-commune"
    }, {
      path: "collectivites/:collectiviteId/epci",
      component: _f8b0e2dc,
      name: "ddt-departement-collectivites-collectiviteId-epci"
    }, {
      path: "collectivites/:collectiviteId/procedure/add",
      component: _4494bb74,
      name: "ddt-departement-collectivites-collectiviteId-procedure-add"
    }]
  }, {
    path: "/frise/:procedureId",
    component: _6a18d814,
    name: "frise-procedureId"
  }, {
    path: "/print/:projectId?",
    component: _017db47b,
    name: "print-projectId"
  }, {
    path: "/trames/:githubRef?",
    component: _733eed98,
    name: "trames-githubRef"
  }, {
    path: "/documents/:githubRef?/pac",
    component: _0b4fb1a2,
    name: "documents-githubRef-pac"
  }, {
    path: "/frise/:procedureId?/add",
    component: _3c665745,
    name: "frise-procedureId-add"
  }, {
    path: "/frise/:procedureId?/invite",
    component: _9e0015d6,
    name: "frise-procedureId-invite"
  }, {
    path: "/frise/:procedureId?/update",
    component: _57f31ed5,
    name: "frise-procedureId-update"
  }, {
    path: "/frise/:procedureId?/:eventId",
    component: _6df62ea2,
    name: "frise-procedureId-eventId"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
